class DisableCopyPaste {
    constructor(el) {
        this.el = el;
        this.eventsName = ['paste', 'copy', 'cut'];

        // Events bindings
        this.$handleEvents = this.handleEvents.bind(this);

        this.init();
    }

    init() {
        this.eventsName.forEach((eventName) => {
            this.el.addEventListener(eventName, this.$handleEvents);
        });
    }

    handleEvents(e) {
        e.preventDefault();
    }

    destroy() {
        this.eventsName.forEach((eventName) => {
            this.el.removeEventListener(eventName, this.$handleEvents);
        });
    }
}

export default class DisableCopyPasteFactory {
    static create(selector) {
        const elementsArray = [...document.querySelectorAll(selector)];

        return elementsArray.map(el => new DisableCopyPaste(el));
    }
}
